export const selector = "#top-webgl .texts img";
export const box = "#top-webgl .texts";
